<template>
  <footer class="footer d-flex">
    <div class="d-flex d-flex--center">
      <div class="footer__item footer__logo footer__logo--samknows">
        <img src="/img/Footer-SK.svg" />
      </div>
      <div class="footer__item footer__logo">
        <img :src="`/img/CST-Footer.svg`" />
      </div>
      <div class="footer__item footer__logo">
        <img src="/img/Footer-2030.svg" />
      </div>
    </div>
    <div class="footer-middle d-flex d-flex--center">
      <ul class="footer-social d-flex d-flex--center">
        <li
          v-for="icon in socialIcons"
          :key="icon.label"
          :aria-label="icon.label"
          class="footer-social__item footer__item"
        >
          <a :href="icon.link" target="_blank">
            <div class="circle-icon">
              <Icon
                :icon="icon.image || icon.label.toLowerCase()"
                class="footer-social__icon"
              />
            </div>
          </a>
        </li>
      </ul>
    </div>
    <div class="footer-right d-flex d-flex--center">
      <div class="footer__item d-flex d-flex--center text-center">
        <router-link to="/cookie-policy">{{
          $t('views.Cookie.title')
        }}</router-link>
        <router-link to="/privacy-policy">{{
          $t('views.Privacy.title')
        }}</router-link>
        <router-link to="/terms-and-conditions">{{
          $t('views.Terms.title')
        }}</router-link>
      </div>
      <div class="footer-right__bottom footer__item text-center">
        <LanguageToggle theme="link" />
      </div>
    </div>
  </footer>
</template>

<script>
import Icon from '@/components/Icon';
import LanguageToggle from '@/components/LanguageToggle';

export default {
  components: {
    Icon,
    LanguageToggle
  },
  computed: {
    socialIcons() {
      return [
        {
          link: 'https://www.facebook.com/CST.KSA',
          image: 'facebook-f',
          label: 'Facebook'
        },
        {
          link: 'https://www.instagram.com/citc_sa/',
          label: 'Instagram'
        },
        {
          link: 'https://twitter.com/CITC_SA',
          label: 'Twitter'
        },
        {
          link: 'https://www.linkedin.com/company/citc_sa/',
          image: 'linkedin-l',
          label: 'LinkedIn'
        },
        {
          link: 'https://www.youtube.com/user/citcksa',
          label: 'Youtube'
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../scss/helpers/mixins';
@import '../scss/base/colors';

.circle-icon {
  background: #02023b;
  width: 31px;
  height: 31px;
  border-radius: 50%;
  line-height: 31px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    background-color: $titles;
  }
}

.text-center {
  text-align: center;
}

.d-flex {
  display: flex;
  &--center {
    align-items: center;
    justify-content: center;
  }
}

.footer {
  background-color: $primary;
  color: $white;
  width: 100%;
  justify-content: space-between;
  @include breakpoint-max(XS) {
    font-size: 12px;
  }

  &__item {
    padding: 14.5px 10px;
    a {
      color: $white;
      text-decoration: underline;
    }
    a + a {
      &::before {
        content: '|';
        margin: 0 10px;
        @include breakpoint-max(XS) {
          margin: 0 5px;
        }
      }
    }
  }

  &__logo {
    height: 55px;
    display: inline-flex;
    align-items: center;
    border-right: $light-border-footer;
    img {
      max-width: 100%;
      height: auto;
    }
    [dir='rtl'] & {
      border-right: none;
      border-left: $light-border-footer;
    }
  }

  &-social {
    list-style: none;
    margin: 0;
    padding: 0;
    &__item {
      line-height: 0;
      padding: 10px 0;
      &:not(:last-child) {
        margin-right: 12px;
        [dir='rtl'] & {
          margin-left: 12px;
          margin-right: 0;
        }
      }
    }
    &__icon {
      &.instagram {
        min-height: 100%;
      }
      &.youtube,
      &.linkedin-l {
        min-height: 100%;
        max-width: 2em;
      }
    }
  }

  // to change
  &-right {
    flex-wrap: wrap;
    [dir='rtl'] & {
      margin-left: 0;
    }
    &__bottom {
      border-left: $light-border-footer;
      [dir='rtl'] & {
        border-left: 0;
        border-right: $light-border-footer;
      }
      @include breakpoint-max(XS) {
        flex: 0 0 100%;
        order: -1;
        border-left: 0;
        border-bottom: $light-border-footer;
      }
    }
  }
}

//large tablet
@include breakpoint-manual(max-width, 1162px) {
  .footer {
    flex-direction: column;
    &-middle {
      order: -1;
    }
    &-right {
      order: -1;
      border-bottom: $light-border-footer;
    }
  }
  .footer__logo--samknows {
    order: 1;
    border-right: none;
    [dir='rtl'] & {
      border-left: none;
    }
  }
  .footer-right__bottom {
    flex: 0 0 100%;
    border-left: none;
    border-top: $light-border-footer;
    [dir='rtl'] & {
      border-right: none;
    }
  }
}
</style>
